// extracted by mini-css-extract-plugin
export default {"indicator":"dropdown-indicator_indicator__cVV0f"};